import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import useModalToggle from "../../../../../../custom_hooks/useModalToggle";
import deleteSvg from "../../../../../../assets/svg/delete-red.svg";
import moment from "moment";
import ProfileView from "../../../../jobs/recommendation/ProfileView";
import { fetchData } from "../../../../../../features/dropdown/dropdownSlice";
import {
  setRowId,
  setSelectedCandidates,
} from "../../../../../../features/folder/folderSlice";

function ScheduledCandidates({ currentSession }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = "api/v1/applications/filter";
  const { open, handleCancel, handleOpen } = useModalToggle();
  const { activeObjActivity } = useSelector((state) => ({
    activeObjActivity: state.folder.activeObj["activity"],
  }));
  const showDrawer = () => {
    handleOpen();
  };
  const onClose = () => {
    handleCancel();
  };

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");
  const { rowId, selectedCandidates } = useSelector((state) => state.folder);
  const handleViewName = async (item) => {
    await setProdd(item);
    await showDrawer();
  };
  const handleDeleteRow = async (person) => {
    const updatedRowId = rowId?.filter((item) => item?.japId !== person?.japId);
    await dispatch(setRowId(updatedRowId));
    await dispatch(setSelectedCandidates(updatedRowId));

    await fetchTableData(updatedRowId);
  };

  function fetchTableData(currentRowIds) { 
    dispatch(
      fetchData({
        url: url,
        limit: null,
        start: 0,
        jobId: activeObjActivity?.jaaJobId,
        progressStatuses: null,
        japIds: currentRowIds?.map((item) => item?.japId),
      })
    );
  }

  const [displayedCandidates, setDisplayedCandidates] = useState([]);
  useEffect(() => {
    setDisplayedCandidates(
      rowId?.filter((item) => item?.japInterviewSession === currentSession)
    );
  }, [rowId, currentSession]);
  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      width: "5%",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Candidate",
      render: (item) => {
        return (
          <div className="cursor-pointer" onClick={() => handleViewName(item)}>
            {item?.japFirstName} {item?.japLastName}
          </div>
        );
      },
    },
    {
      title: "japId",
      dataIndex: "japId",
    },
    {
      title: "Match Score",
      dataIndex: "japMatchingScore",
      render: (item) => {
        return (
          <div className="py-[.25rem] px-[.5rem] flex items-center justify-center gap-[.625rem] rounded-[.25rem] bg-[#569D6E] opacity-[0.8]">
            {item}
          </div>
        );
      },
    },
    {
      title: "Date Shortlisted",
      dataIndex: "japShortlistedDate",
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "--"),
      sorter: (a, b) =>
        moment(a.japShortlistedDate).valueOf() -
        moment(b.japShortlistedDate).valueOf(),
    },
    {
      title: "Start Time",
      dataIndex: "japInterviewStartTime",
    },
    {
      title: "End Time",
      dataIndex: "japInterviewEndTime",
    },
    {
      title: "Actions",
      render: (item) => (
        <>
          <img
            src={deleteSvg}
            alt="deleteSvg"
            className="cursor-pointer"
            onClick={() => handleDeleteRow(item)}
          />
        </>
      ),
    },
  ];
  return (
    <>
      <div className="flex items-center text-[#000] text-[.875rem] font-dmSans font-[400] mt-[1.5rem] ">
        Candidates Scheduled
      </div>

      <Table
        rowSelection={false}
        className="w-full mt-[.5rem]"
        scroll={{
          x: "auto",
        }}
        rowKey={(record) => record?.japId}
        columns={columns}
        dataSource={displayedCandidates}
        pagination={{
          position: ["bottomRight"],
          total: rowId?.length,
          pageSize: 10,
          showSizeChanger: false,
          hideOnSinglePage: true,
        }}
      />

      <ProfileView
        onClose={onClose}
        openDrawer={open}
        prodd={prodd}
        action={false}
      />
    </>
  );
}

export default ScheduledCandidates;
